import { useContext } from "react";

import {
  ClientBudgetMonthContextType,
  ClientBudgetMonthContext,
} from "./ClientBudgetMonthContext";

export const useClientBudgetMonth = (): ClientBudgetMonthContextType => {
  const context = useContext(ClientBudgetMonthContext);
  if (!context) {
    throw new Error("useClientBudgetMonth must be used within a ClientBudgetMonthProvider");
  }
  return context;
};
